// extracted by mini-css-extract-plugin
export default {"contents_wrap":"SemoAi_contents_wrap__hGQ-L","mobile_contents":"SemoAi_mobile_contents__hNV5-","pc_contents":"SemoAi_pc_contents__uI7Mv"};